/* src/app/timeline-transport/partals/timeline-transport-accepted-orders/timeline-transport-accepted-orders.component.scss */
.header {
  color: white;
  padding: 0.5rem 0.75rem;
  background: #1e293b;
  border-radius: 0 0.6rem 0 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: nowrap;
  gap: 0.5rem;
  flex: 0 0 auto;
}
.headerLabel {
  font-size: 0.8rem;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.bodyContainer {
  background-color: white;
  padding: 0.5rem 0.75rem;
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
}
.acceptedOrdersList {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
}
.acceptedOrdersFilters {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}
.acceptedOrdersSelect {
  font-size: 0.7rem;
}
.acceptedOrdersSelect ::ng-deep .ng-select-container {
  min-height: 1.9rem;
  height: 1.9rem;
}
.acceptedOrdersInput {
  font-size: 0.7rem;
  height: 1.9rem;
  padding: 0.25rem 0.5rem;
}
.acceptedOrdersActionRow {
  display: flex;
  gap: 0.35rem;
}
.acceptedOrdersActionRow .btn {
  flex: 1;
}
.acceptedOrdersDivider {
  height: 1px;
  background: #e2e8f0;
  margin: 0.6rem 0;
}
.acceptedOrdersContainer {
  position: fixed;
  width: 17rem;
  font-size: 0.65rem;
  left: 4.5rem;
  top: 8.5rem;
  bottom: 0.5rem;
  display: flex;
  flex-direction: column;
  z-index: 99;
  border-radius: 0 0.6rem 0.6rem 0.6rem;
  box-shadow: 2px 2px 5px rgba(15, 23, 42, 0.12);
}
.acceptedOrdersContainer .btn-small {
  width: 2rem;
}
.orderContainer {
  background-color: #e2e8f0;
}
.orderContainer.old {
  background-color: pink;
}
.orderContainer {
  width: 100%;
  padding: 0.5rem;
  padding-right: 3.5rem;
  margin-bottom: 0.5rem;
  border-radius: 0.4rem;
  cursor: grab;
  position: relative;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: auto;
}
.orderContainer.orderInfoActive {
  outline: 2px dashed #006498;
  outline-offset: 2px;
}
.orderQtyBanner {
  position: absolute;
  top: 0;
  right: 0;
  min-width: 3rem;
  padding: 0.2rem 0.4rem;
  font-size: 0.7rem;
  font-weight: bold;
  text-align: center;
  color: white;
  border-radius: 0 0.4rem 0 0.4rem;
}
.orderQtyBanner.badge-secondary {
  background-color: #64748b !important;
}
.orderQtyBanner.badge-primary {
  background-color: #006498 !important;
}
.orderQtyBanner.badge-success {
  background-color: #3f8f5f !important;
}
.orderQtyBanner.badge-danger {
  background-color: #b45454 !important;
}
.orderDetails {
  width: 100%;
}
.orderDetailLabel {
  font-size: 0.6rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  color: #64748b;
}
.dragging {
  opacity: 0.5;
  transform: scale(0.8);
}
.gridPagination {
  width: 100%;
}
.gridPagination ul {
  display: table;
  margin: 0 auto;
  list-style-type: none;
}
.gridPagination li {
  display: inline-block;
}
.gridPagination li a.active {
  text-decoration: underline;
}
.own {
  background-color: #006498;
  color: white;
}
.expired {
  background-color: #1e293b;
  color: white;
}
.clone {
  width: 1rem;
}
/*# sourceMappingURL=timeline-transport-accepted-orders.component.css.map */
